import React, { useEffect, useState } from "react";
import { db, collection, getDocs } from "../firebase";
import { Card, Button, Container, Row, Col, Modal, Badge } from "react-bootstrap";
import "./blog.css"; // Ensure styles are consistent
import "react-quill/dist/quill.snow.css"; // Import default styles

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchBlogs = async () => {
      const querySnapshot = await getDocs(collection(db, "blogs"));
      const blogsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBlogs(blogsData);
    };

    fetchBlogs();
  }, []);

  const handleShowModal = (blog) => {
    setSelectedBlog(blog);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBlog(null);
  };

  return (
    <div className="blogs-page">
      {/* Navigation Bar */}
      <nav className="navbar">
        <div className="container">
          <h1 className="logo">My Blog</h1>
          <ul className="nav-links">
            <li><a href="/" className="nav-link">Home</a></li>
            <li><a href="#about" className="nav-link">About</a></li>
            <li><a href="#projects" className="nav-link">Projects</a></li>
            <li><a href="#contact" className="nav-link">Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Blog List */}
      <Container className="mt-5">
        <h2 className="text-center mb-4 section-title">Latest Blogs</h2>
        <Row>
          {blogs.map((blog) => (
            <Col key={blog.id} md={4} className="mb-4">
              <Card className="blog-card shadow-lg">
                <Card.Body>
                  <Card.Title className="blog-title">{blog.title}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {new Date(blog.date).toDateString()}
                  </Card.Subtitle>

                  {/* Tags Section */}
                  <div className="mb-2">
                    {Array.isArray(blog.tags)
                      ? blog.tags.map((tag, index) => (
                          <Badge key={index} pill bg="warning" className="me-1 text-dark">
                            {tag}
                          </Badge>
                        ))
                      : typeof blog.tags === "string"
                      ? blog.tags.split(",").map((tag, index) => (
                          <Badge key={index} pill bg="warning" className="me-1 text-dark">
                            {tag.trim()}
                          </Badge>
                        ))
                      : null}
                  </div>

                  <Card.Text className="blog-text">
                  <div dangerouslySetInnerHTML={{ __html: blog.content.substring(0, 100) + "..." }} />
                </Card.Text>

                  <Button variant="warning" className="custom-button" onClick={() => handleShowModal(blog)}>
                    Read More
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Back to Home Button */}
      <div className="text-center mt-5">
        <a href="/" className="btn btn-outline-warning back-home-btn">Back to Home</a>
      </div>

      {/* Blog Details Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        {selectedBlog && (
          <>
            <Modal.Header closeButton className="modal-header-custom">
              <Modal.Title>{selectedBlog.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body-custom">
              <p className="text-muted">{new Date(selectedBlog.date).toDateString()}</p>

              {/* Render formatted content */}
              <div className="modal-content" dangerouslySetInnerHTML={{ __html: selectedBlog.content }} />
            </Modal.Body>

            <Modal.Footer>
              <Button variant="dark" className="custom-button" onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Blogs;
